import { Outlet } from "react-router-dom";

import { useUser } from "@app/shared/lib/hooks/useUser";

import { AppShell } from "../AppShell/AppShell";
import { CookieNotification } from "../CookieNotification";
import { LoadingOverlay } from "../LoadingOverlay";
import { UIAppState } from "../UIAppState/UIAppState";

export const BasicLayout: React.FC = () => {
  const user = useUser();

  if (user.user == null) return <LoadingOverlay position="absolute" />;

  return (
    <>
      <AppShell>
        <Outlet />
      </AppShell>
      <CookieNotification />
      <UIAppState />
    </>
  );
};
